type DownloadParams = {
  filename: string;
  fileString: string;
  fileType: string;
};

export const download = ({
  filename,
  fileString,
  fileType,
}: DownloadParams) => {
  const element = document.createElement('a');
  element.setAttribute(
    'href',
    `data:${fileType};charset=utf-8,` + encodeURIComponent(fileString),
  );
  element.setAttribute('download', filename);
  element.click();
  element.remove();
};

export const downloadFile = (file: File) => {
  const element = document.createElement('a');
  element.href = URL.createObjectURL(file);
  element.download = file.name;
  element.click();
  element.remove();
  URL.revokeObjectURL(element.href);
};

export const fetchStringContent = (
  url: string,
  init?: RequestInit,
  errorMsg?: string,
): Promise<string> =>
  fetch(url, init).then((res) => {
    if (!res.ok) throw new Error(errorMsg || 'Something went wrong'); // fetch does not throw errors directly

    return res.text();
  });

export const fetchStringContentBlob = (
  url: string,
  init?: RequestInit,
  errorMsg?: string,
): Promise<Blob> =>
  fetch(url, init).then((res) => {
    if (!res.ok) throw new Error(errorMsg || 'Something went wrong'); // fetch does not throw errors directly

    return res.blob();
  });

export const blobToDataURL = (blob: Blob): Promise<string> =>
  new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result as string);
    reader.onerror = () => reject(reader.error);
    reader.onabort = () => reject(new Error('File read aborted'));
    reader.readAsDataURL(blob);
  });
